export enum DemographicsInsightEnum {
  ATHLETE_DISTRIBUTION_BY_SPORT = 'ATHLETE_DISTRIBUTION_BY_SPORT',
  EDUCATION_LEVELS_OF_APPLICANTS = 'EDUCATION_LEVELS_OF_APPLICANTS',

  // TODO: Will be implemented in the future
  // SOURCE_OF_HIRE = 'SOURCE_OF_HIRE',
}
